import * as R from 'ramda'
import { createSelector } from 'reselect'
import * as c from './constants'

const getExperimentationState = R.propOr({}, c.NAME)

const isFeaturesLoading = createSelector(
  getExperimentationState,
  (state) => !state.init || state.loading
)

const getFeatures = R.pipe(
  getExperimentationState,
  R.prop('features')
)

const getFeaturesError = R.pipe(
  getExperimentationState,
  R.prop('error')
)

export {
  isFeaturesLoading,
  getFeatures,
  getFeaturesError
}
